import { defineMessages } from "react-intl";

const messages = defineMessages({
    close: {
        id: "general.close",
    },
    hintRight: {
        id: "solfaAlternateDragModal.hint.right",
    },
    hintLeft: {
        id: "solfaAlternateDragModal.hint.left",
    },
});

export default messages;
